import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface ToastProps {
    message: string;
    isVisible: boolean;
    onClose: () => void;
    duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, isVisible, onClose, duration = 3000 }) => {
    const { theme } = useTheme();

    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [isVisible, duration, onClose]);

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: theme.spacing.MEDIUM,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: theme.colors.SURFACE,
            color: theme.colors.TEXT,
            padding: theme.spacing.MEDIUM,
            borderRadius: theme.borderRadius.SMALL,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 1000,
            animation: 'slideUp 0.5s ease-out, slideDown 0.5s ease-in 2.5s forwards'
        }}>
            {message}
            <style>
                {`
                    @keyframes slideUp {
                        from { transform: translate(-50%, 100%); }
                        to { transform: translate(-50%, 0); }
                    }
                    @keyframes slideDown {
                        from { transform: translate(-50%, 0); }
                        to { transform: translate(-50%, 100%); }
                    }
                `}
            </style>
        </div>
    );
};

export default Toast; 